(ns teamoesterreich.user-mode.landing.actual-news.toe-info
  (:require
    [clojure.string]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.firebase.remote-config :as remote-config]
    [teamoesterreich.text.get-text :as txt]                 ;usage
    ))



(defn get-it []


  [mui/grid
   {:container   true
    :direction   "row"
    :justify     "center"
    :align-items "center"
    :spacing     1
    :style       {}
    }

   [mui/grid
    {:item  true
     :md    12
     :xs    12
     :style {:maxWidth "1165px"}
     }

    [mui/paper
     [:h1 (txt/txt :landing "Willkommen beim Team")]
     [mui/grid
      {:container   true
       :direction   "row"
       :justify     "center"
       :align-items "center"
       :spacing     1
       :style       {}
       }

      [mui/grid
       {:item true
        :md   6
        :xs   12
        }
       [:img {:src   "/custom/img/krise.jpg"
              :style {:maxWidth "400px" :objectFit "contain"}
              :alt   "In der Krise"}]]


      [mui/grid
       {:item true
        :md   6
        :xs   12
        }
       [:div
        {:style {:textAlign "left" :padding "20px"}}
        [:div {:dangerouslySetInnerHTML {:__html (remote-config/get-string "presentation_block1_html")}}]
        ]]



      [mui/grid
       {:item true
        :md   6
        :xs   12
        }
       [:div
        {:style {:textAlign "right" :padding "20px"}}
        [:div {:dangerouslySetInnerHTML {:__html (remote-config/get-string "presentation_block2_html")}}]
        ]]


      [mui/grid
       {:item true
        :md   6
        :xs   12
        }
       [:img {:src   "/custom/img/alltag.jpg" :alt "Im Alltag"
              :style {:maxWidth "400px" :objectFit "contain"}}]]

      ]]
    ]]

  )
